declare var defaultIsGrid;


export class productController {
    product;
    productDetailUrl
    constructor(private $compare, private $mPath) {
        "ngInject"
    }

    addtocompare(product) {
        this.$compare.add(product.ProductTypeID, product)
    }
    $onChanges() {
        this.$mPath.get().then(
            response => {
                this.product.detailUrl = `${response.StoreProductDetail}/pID/${this.product.ProductID}/`
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/product/product.controller.ts